import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../SvgIcon';

var ArrowLeft = function ArrowLeft(props) {
  return _jsx(SvgIcon, __assign({}, props, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5656 6.43427C10.8781 6.74669 10.8781 7.25322 10.5656 7.56564L6.93132 11.2H19C19.4418 11.2 19.8 11.5581 19.8 12C19.8 12.4418 19.4418 12.8 19 12.8H6.93132L10.5656 16.4343C10.8781 16.7467 10.8781 17.2532 10.5656 17.5656C10.2532 17.8781 9.74669 17.8781 9.43427 17.5656L4.43427 12.5656C4.12185 12.2532 4.12185 11.7467 4.43427 11.4343L9.43427 6.43427C9.74669 6.12185 10.2532 6.12185 10.5656 6.43427Z"
    })
  }));
};

export default ArrowLeft;